<template>
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="title">
              <el-input v-model="form.title" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="time">
              <el-date-picker v-model="form.time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                placeholder="请选择发表日期"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="author">
              <el-input v-model="form.author" placeholder="请输入作者"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="6">
            <el-form-item>
              <el-select v-model="form.type" placeholder="请选择发布单位">
                <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd()">
            <svg-icon icon-class="add" />&nbsp;添加学术论文
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="title" label="学术论文标题" show-overflow-tooltip></el-table-column>
          <el-table-column prop="author" label="作者" show-overflow-tooltip></el-table-column>
          <el-table-column prop="publishTime" label="发表日期" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="projectName" label="发布单位" show-overflow-tooltip></el-table-column> -->

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="30%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">详情</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog title="学术论文"
        :close-on-click-modal="false" @close="onCancel" :visible.sync="dialogVisible"
        :width="'800px'">
        <el-form ref="form" :model="addForm" :rules="rules" label-width="96px">
          <el-form-item label="标题：" class="mb-30" prop="title">
            <el-input v-model="addForm.title" :disabled="operation == 'view'" placeholder="请输入学术论文标题" />
          </el-form-item>

          <el-form-item label="作者：" class="mb-30" prop="author">
            <el-input v-model="addForm.author" :disabled="operation == 'view'" placeholder="请输入作者" />
          </el-form-item>

          <el-form-item label="发表时间：" class="mb-30" prop="publishTime">
            <el-date-picker v-model="addForm.publishTime" :disabled="operation == 'view'" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" type="date" placeholder="请选择发表日期"></el-date-picker>
          </el-form-item>

          <!-- <el-form-item class="mb-30" prop="language">
            <el-select v-model="addForm.language" placeholder="请选择发布单位">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="简介：" class="mb-30" prop="summary">
            <!-- <el-input type="textarea" v-model="addForm.summary" :disabled="operation == 'view'" placeholder="请输入内容" /> -->
            <cmp-ckeditor ref="myCkeditor" :readOnly="operation == 'view'" :defaultMsg="addForm.summary" :id="`ue1`"
              :height="150"></cmp-ckeditor>

          </el-form-item>


          <el-form-item label="附件 :">
            <!-- 上传 -->
            <cmpUploadProgress ref="cmpUploadProgress"
              :businessType="'xslw'"
              :showUpload="operation == 'view' ? false : true"
              :callFun="uploadCallback"
              :showTip="operation == 'view' ? false : true" 
              :fileList="addForm.fileList"
              :accept="`.pdf`">
            </cmpUploadProgress>
          </el-form-item>

          <!-- <el-form-item class="avatar-uploader-form" required>
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept="image/*" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" style="height:120px;width: 100%;object-fit:contain;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传学术论文封面</div>
              </div>
            </el-upload>
          </el-form-item> -->
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation !== 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import cmpCkeditor from '@cmp/editor/ckeditor'
import cmpUploadProgress from '@cmp/my-upload/upload-progress' // 上传组件

export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  components: { cmpCkeditor, cmpUploadProgress },
  data() {
    return {
      form: {
        title: '',
      },
      operation: 'add',
      addForm: {},
      rules: {
        title: [{ required: true, message: '学术论文名称不能为空', trigger: 'blur' }],
        author: [{ required: true, message: '作者不能为空', trigger: 'blur' }],
        publishTime: [{ required: true, message: '发表日期不能为空', trigger: 'blur' }],

      },
      configData: {
        tableName: 'collect'
      },
      imgUrl: "",
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet.getScienceList({
        type: 4,
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },


    // 重置查询
    resetForm() {
      this.form = {
        title: '',
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    },


    // 文件上传回调
    uploadCallback(fileStr) {
      console.log(fileStr)

      this.addForm.fileIds = fileStr
    },

    handleView(obj) {
      this.operation = "view"
      this.$api.applet.getScienceDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
            if (res.result.img) {
              this.imgUrl = res.result.img
            }

          }
        }
      })
    },

    // 新增
    handleAdd() {
      this.operation = "add"
      this.dialogVisible = true
    },

    handleEdit(obj) {
      console.log(123, obj)

      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      if (obj.img) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.img}`
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.delScience({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)

      if (this.imageTypes.includes(fileType)) {
        return true
      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return false
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.img = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    onSubmit() {
      const self = this
      let content = this.$refs.myCkeditor.getContent() // 调用子组件方法
      if (!content) {
        this.$message.info('请输入论文概述')
        return
      } else {
        this.addForm.summary = content
      }
      this.addForm.type = 4
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "addScience"
          if (this.addForm.id) {
            url = "updateScience"
          }
          this.$api.applet[url](this.addForm).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '学术论文修改成功' : '新增学术论文成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getData()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ""
      this.$refs["form"].clearValidate()
      this.$refs.myCkeditor.initEditor()

    },

  },
  created() {
    this.getData()

    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  .el-form-item {
    .el-form-item__content {
      .el-date-editor,
      .el-select {
        width: 100%;
      }
    }

    &.avatar-uploader-form {
      display: flex;

      .tip-img {
        left: 0;
      }
      /deep/ .el-form-item__content {
        flex: 1;
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /deep/.el-upload {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
        }

        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
    }
  }
}
</style>